// Package Imports
import { toJS } from "mobx";
import moment from "moment";

import axios from "utils/axios";
import * as APITypes from 'constants/API';
import isObjectEmpty from "utils/isObjectEmpty";
import AuthStore from "modules/login/store/AuthStore"
import FamilyMemberFieldStructureObject from "../form/FamilyMemberFieldStructureObject"
import journeyTypeEnum from "constants/journeyTypeEnum"
import EmployeeMemberFieldStructureObject from "./EmployeeMemberFieldStructureObject"
import employeesList from "./employeesList"
import createNewObject from "utils/createNewObject"
import capitalizeFirstLetter from "utils/capitalizeFirstLetter";
import checkIsValueEmpty from "utils/checkIsValueEmpty"
import addEmployeeMemberFromUtils from "utils/addEmployee";
import FamilyDetailsStore from "../store/FamilyDetailsStore"
import generateRandomString from "utils/generateRandomString";
import fetchDeselectedExpenses from "utils/fetchDeselectedExpenses"
import fetchDeselectedExpensesForEmi from "utils/fetchDeselectedExpensesForEmi"
import { upperCase } from "lodash";
import FamilyMemberTypeEnum from "../FamilymemberTypeEnum";
import { EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, KEYMAN, MWP_ACT, PARTNERSHIP } from "constants/ CustomerType";
import FieldTypeEnum from "../form/FieldTypsEnum";



const sendnonIndividualDataToServer = async (formController) => {
    let { isValid } = await formController.validate({ showErrors: true })

    if (isValid) {
        let { members, liabilities, monthly_expense, savings, monthly_emi } = formController.values()

        let selectedMonthlyExpense = removeEmptyObject(monthly_expense)
        let monthlyEmi = removeEmptyObject(monthly_emi)
        let selectedLiabilities = removeEmptyObject(liabilities)
        let selectedSavings = removeEmptyObject(savings)

        let expenseList = [
            ...selectedMonthlyExpense,
            ...selectedLiabilities,
            ...selectedSavings,
        ]

        let emiList = [];
        let monthlyEmiObject = { ...monthlyEmi };
        for (const selectedKey in monthlyEmiObject) {
            let objPrefix = monthlyEmiObject[selectedKey];
            let isDisabled = isObjectEmpty(monthlyEmiObject[selectedKey].option_range)

            if (!isDisabled) {
                emiList.push({
                    action: "save",
                    id: objPrefix.option_range.id,
                    expense_range_id: objPrefix.option_range.id,
                    expense_range_key: objPrefix.option_range.label,
                    expense_range_value: objPrefix.option_range.label,
                    paid_years: objPrefix.paid_years.value,
                    total_years: objPrefix.total_years.value,
                    user_journey: AuthStore.journeyId,
                });
            }
        }

        expenseList.map((item) => {
            item.action = 'save';
            item.expense_range_id = item.id
            item.expense_range_key = item.label
            item.expense_range_value = item.value
            return item
        })

        const selectedMemberList = fetchSelectedEmployees(members, formController)

        let values = formController.values();

        let data = []
        let familyMembersList = values.members

        for (const memberData in familyMembersList) {

            if (selectedMemberList.includes(memberData)) {
                data.push(familyMembersList[memberData])
            }
        }

        data.map(item => {

            if (!checkIsValueEmpty(item.salutation)) {
                item.salutation = item.salutation.id
            }

            if (!checkIsValueEmpty(item.nationality)) {
                item.nationality = item.nationality.id
            }

            if (!checkIsValueEmpty(item.monthly_income_dropdown_option)) {
                item.monthly_income_dropdown_option = item.monthly_income_dropdown_option.id
            }
            if (!checkIsValueEmpty(item.dob)) { 
                if (!moment(item.dob, 'DD-MM-YYYY', true).isValid()) {
                    item.dob = moment(item.dob).format('YYYY-MM-DD')
                } else {
                    item.dob = moment(item.dob, 'DD-MM-YYYY').format('YYYY-MM-DD')
                }
            }

            if (!checkIsValueEmpty(item.current_life_cover)) {
                item.current_life_cover = item.current_life_cover.id
            }

            if (!isObjectEmpty(item.gender)) {
                item.gender = item.gender.value
            }

            item.monthly_income = item.monthly_income_value
            item.is_selected = true

            item.first_name = capitalizeFirstLetter(item.first_name)
            item.middle_name = capitalizeFirstLetter(item.middle_name)
            item.last_name = capitalizeFirstLetter(item.last_name)

            for (const [key, value] of Object.entries(item)) {
                if (typeof (value) === 'string') {
                    if (value === '') {
                        delete item[key]
                    }

                }

                if (typeof (value) === 'object') {
                    if (isObjectEmpty(value)) {
                        delete item[key]
                    }
                }
            }

            return item
        })

        let journeyData = toJS(AuthStore.journeyData);
        let productDetailsList = journeyData.family_product_details_list.filter((item) => item.is_selected ) // need to filter first selected needs
        
        let details = {}
        let termNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 4)
        let gmmNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 1)
        let childNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 2)
        let retirementNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 3)
        let healthNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 5)

        if(Object.keys(details).length === 0 && termNeedData) { details = termNeedData}
        if(Object.keys(details).length === 0 && gmmNeedData) { details = gmmNeedData}
        if(Object.keys(details).length === 0 && childNeedData) { details = childNeedData}
        if(Object.keys(details).length === 0 && retirementNeedData) { details = retirementNeedData}
        if(Object.keys(details).length === 0 && healthNeedData) { details = healthNeedData}

        if(journeyData.family_details_list.length !== 1 &&( journeyData?.family_details_list[0].family_member_type === "EMPLOYEE" || journeyData?.family_details_list[0].family_member_type === "FAMILY_MEMBER") ) {
        
            // Change LA API
        let selectedLaDetails = data.find((item)=> item.life_assured)

        if(details.family !== selectedLaDetails?.id) {
            let changeLaRequest = []
            productDetailsList.forEach((item) => {
                changeLaRequest.push({
                    dob : selectedLaDetails.dob,
                    monthly_income : selectedLaDetails.monthly_income || selectedLaDetails.monthly_income_dropdown_option, 
                    family_member_id : selectedLaDetails.id,
                    family_product_id : item.id,
                    need : item.need,
                    is_selected : item.is_selected,
                    target_amount_value : item.target_amount_value,
                    target_amount : item.target_amount,
                    payout_mode : item.payout_mode
                })
            })
            await axios.post(
                APITypes.CHANGE_LA_ALL_NEEDS,
                changeLaRequest
            )
        }
        
        // Change PR API
        let selectedPrDetails = data.find((item)=> item.proposer)
        if(details.proposer_family !== selectedPrDetails.id) {
            let changePrRequest = {}
            productDetailsList.forEach((item) => {
                changePrRequest = {
                    journey_id: AuthStore.journeyId,
                    proposer_id : selectedPrDetails.id,
                    family_product_id : item.id,
                    need : item.need,
                }
            })
            await axios.post(
                APITypes.CHANGE_PR_ALL_NEEDS,
                changePrRequest
            )
        }
    }

        await submitEORFMDataToTheServer(formController, selectedMemberList, expenseList, emiList)

        global.loading(false);

    } else {
        console.log("Error are ", formController.errors())
    }
}


const checkIfFamilyMemberAreAdded = (membersList) => {

    let defaultSelectedOptionKeys = ["salutation", 'nationality', 'is_selected', 'family_member_type', 'gender', 'current_life_cover', 'monthly_income_dropdown_option', 'monthly_income_value', 'life_assured', 'proposer', 'is_member_selected']
    let selectedMemberList = [];

    for (const member in membersList) {

        for (const memberField in membersList[member]) {

          
            if (defaultSelectedOptionKeys.includes(memberField)) {
                continue
            }

            if (!checkIsValueEmpty(membersList[member][memberField])) {
                selectedMemberList.push(member)
                break;
            }
        }
    }

    // selectedMemberList.push("self")

    return selectedMemberList
}

export const fetchSelectedEmployees = (membersList, formController) => {

    let selectedMemberList = checkIfFamilyMemberAreAdded(membersList, formController)
    for (let member in membersList) {
        let isSelected = false
        if (selectedMemberList.includes(member)) {
            isSelected = true
        }
        formController.$("members").$(member).extra.isSelected = isSelected
    }

    return selectedMemberList
}


export const submitEORFMDataToTheServer = async (formController, selectedMemberList, expenseList = [], emiList = []) => {

    global.loading(true);

    let values = formController.values();

    let data = []
    let familyMembersList = values.members

    for (const memberData in familyMembersList) {

        if (selectedMemberList.includes(memberData)) {
            data.push(familyMembersList[memberData])
        }
    }

    data.map(item => {

        if (!checkIsValueEmpty(item.salutation)) {
            item.salutation = item.salutation.id
        }

        if (!checkIsValueEmpty(item.nationality)) {
            item.nationality = item.nationality.id
        }

        if (!checkIsValueEmpty(item.monthly_income_dropdown_option)) {
            item.monthly_income_dropdown_option = item.monthly_income_dropdown_option.id
        }
        if (!checkIsValueEmpty(item.dob)) {
            if (!moment(item.dob, 'DD-MM-YYYY', true).isValid()) {
                item.dob = moment(item.dob).format('YYYY-MM-DD')
            } else {
                item.dob = moment(item.dob, 'DD-MM-YYYY').format('YYYY-MM-DD')
            }
        }

        if (!checkIsValueEmpty(item.current_life_cover)) {
            item.current_life_cover = item.current_life_cover.id
        }

        if (!isObjectEmpty(item.gender)) {
            item.gender = item.gender.value
        }

        item.monthly_income = item.monthly_income_value
        item.is_selected = true

        item.first_name = capitalizeFirstLetter(item.first_name)
        item.middle_name = capitalizeFirstLetter(item.middle_name)
        item.last_name = capitalizeFirstLetter(item.last_name)

        for (const [key, value] of Object.entries(item)) {
            if (typeof (value) === 'string') {
                if (value === '') {
                    delete item[key]
                }

            }

            if (typeof (value) === 'object') {
                if (isObjectEmpty(value)) {
                    delete item[key]
                }
            }
        }

        return item
    })

    let monthleExpenseDeSelectedList = fetchDeselectedExpenses(formController, 'monthly_expense')
    let monthleSavingsDeSelectedList = fetchDeselectedExpenses(formController, 'liabilities')
    let currentSavingsDeSelectedList = fetchDeselectedExpenses(formController, 'savings')
    let emiDeSelectedList = fetchDeselectedExpensesForEmi(formController, 'monthly_emi')

    let deSelectedExpenseList = [
        ...monthleExpenseDeSelectedList,
        ...monthleSavingsDeSelectedList,
        ...currentSavingsDeSelectedList
    ]

    let deselectExpensesData = deSelectedExpenseList.map(item => item.journeyExpenseId)
    // let selfData = data.find((item) => item.family_member_type === FamilyMemberTypeEnum.SELF)
    // if (deselectExpensesData.length > 0) {
    //     await axios.post(
    //         APITypes.DESELECT_EXPENSE,
    //         {
    //             "family_member_id": selfData.id,
    //             "id": deselectExpensesData
    //         }
    //     )
    // }

    // if (emiDeSelectedList.length > 0) {
    //     await axios.post(
    //         APITypes.DESELECT_EMI,
    //         {
    //             "family_member_id": selfData.id.toString(),
    //             "id": emiDeSelectedList
    //         }
    //     )
    // }


    let response = await axios.post(
        APITypes.SAVE_FAMILY_DETAILS,
        data = {
            journey_id: values.journey_id,
            family_list: data,
            expense_list: expenseList,
            emi_list: emiList
        }
    )

    return response;
}


const addEmployees = async (formController, hideModal) => {

    addEmployeeMemberFromUtils(
        formController,
        fetchSelectedEmployees,
        submitEORFMDataToTheServer,
        AuthStore,
        reInitializeEmployeeData,
        hideModal
    )
}

const checkIsProtectionNeedSelected = (familyProductDataList) => {
    let isProtectionNeedSelected = familyProductDataList?.some(
        (item) => {

            if (item.is_selected) {
                return item.need_unique_name === 'protection_for_my_family' || item.need_unique_name === 'protection_for_my_health'
            }

            return false
        })
    return isProtectionNeedSelected
}


const addNewMember = (memberType, formController) => {
    // member type will be FamilyMemberTypeEnum
    let familyData = employeesList.find((member) => member.memberType === memberType)

    const employeeData = Object.entries(formController.$("members").get())

    let nationalMasterList = toJS(FamilyDetailsStore.nationalityList);
    let salutationMasterList = toJS(FamilyDetailsStore.salutationList);
    let lifeCoverList = toJS(FamilyDetailsStore.lifeCoverList);
    let journeyData = toJS(AuthStore.journeyData);
    let monthlyIncomeMasterList = FamilyDetailsStore.monthlyIncomelist

    let isProtectionNeedSelected = checkIsProtectionNeedSelected(journeyData.family_product_details_list)

    let familyMemberFieldObjectData = generateMemberEmptyDataStrucutre(
        familyData,
        lifeCoverList,
        nationalMasterList,
        salutationMasterList,
        monthlyIncomeMasterList,
        isProtectionNeedSelected
    )

    let memberName = familyMemberFieldObjectData.name.replace(/[0-9]/g, '');
    let memberLabel = familyMemberFieldObjectData.label.replace(/[0-9]/g, '')
    
    if(AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === MWP_ACT){
        familyMemberFieldObjectData.name = memberName + (employeeData.length + 1)
        familyMemberFieldObjectData.label = memberLabel + (employeeData.length  + 1)
    }
    else{
        familyMemberFieldObjectData.name = memberName + employeeData.length
        familyMemberFieldObjectData.label = memberLabel + employeeData.length
    }
       formController.$("members").add(familyMemberFieldObjectData)
    formController.$("members").$(familyMemberFieldObjectData.name).$('is_member_selected').set("disabled", true)
    formController.$("members").$(familyMemberFieldObjectData.name).extra.isSelected = false

}

const createFamilyMemberFieldData = (lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, familyProductData, memberDetails) => {

    let memberFieldsList = []


    let isProtectionNeedSelected = checkIsProtectionNeedSelected(familyProductData)

    employeesList.forEach((item) => {

        let memberFieldObject = generateMemberEmptyDataStrucutre(item, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, isProtectionNeedSelected, memberDetails)
        memberFieldsList.push(memberFieldObject)
    })

    //  console.log("memberFieldsList ",memberFieldsList)

    return memberFieldsList

}

const generateMemberEmptyDataStrucutre = (familyObj, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, isProtectionNeedSelected, memberDetailsList) => {
    let memberFieldObject = createNewObject(EmployeeMemberFieldStructureObject)
    let journeyData = toJS(AuthStore.journeyData);
    let journeyList = toJS(AuthStore.journeyList)

    let showProposer = [EMPLOYER_EMPLOYEE_SCHEME_A, HUF, PARTNERSHIP, KEYMAN]


    // const selfJourneyTypeValue = journeyData.journey_details.journey_type
    //const selfJourneyTypeOption = journeyList.find(singleJourney => singleJourney.id == selfJourneyTypeValue).label

    let selectedNation = {}
    let employerGender = { id: 3, label: 'Company', value: 'Company' }

    const nationalityObj = {}
    nationalMasterList.forEach((item) => {
        nationalityObj[item.label] = item
    })

    let memberDetails = {}
    if (memberDetailsList && memberDetailsList.length > 2) {
        memberDetailsList.forEach((item) => {
            if (item[0] === familyObj.name) {
                memberDetails = item[1]
            }
        })
    }

    memberFieldObject.name = familyObj.name
    memberFieldObject.label = familyObj.label
    memberFieldObject.extra.isSelected = familyObj.defaultSelected
    memberFieldObject.fields.find(formField => formField.name === 'family_member_type').value = familyObj.memberType

    // set nationality master option list
    memberFieldObject.fields.find(formField => formField.name === 'nationality').extra.optionList = nationalMasterList
    memberFieldObject.fields.find(formField => formField.name === 'nationality').value = nationalMasterList[0] // selectedNation

    // set life cover master option list
    memberFieldObject.fields.find(formField => formField.name === 'current_life_cover').extra.optionList = lifeCoverList


    // setting default value of cover to No cover
    memberFieldObject.fields.find(formField => formField.name === 'current_life_cover').value = lifeCoverList[0]

    memberFieldObject.fields.find(formField => formField.name === 'gender').extra.optionList = fecthGenderOptionList(familyObj.name)

    // set Monthly Income Dropdown list
    memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').extra.optionList = monthlyIncomeMasterList
    // memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').value = monthlyIncomeMasterList[0]

    // set salutation master option list
    // memberFieldObject.fields.find(formField => formField.name === 'salutation').extra.optionList = salutationMasterList
    // memberFieldObject.fields.find(formField => formField.name === 'salutation').value = salutationMasterList[0]

    if (familyObj.memberType === FamilyMemberTypeEnum.EMPLOYER) {
        memberFieldObject.fields.find(formField => formField.name === 'salutation').extra.optionList = salutationMasterList
        memberFieldObject.fields.find(formField => formField.name === 'salutation').value = salutationMasterList[6]
        memberFieldObject.fields.find(formField => formField.name === 'dob').extra.maxDate = ""
        memberFieldObject.fields.find(formField => formField.name === 'dob').extra.minDate = moment().subtract('years')
        memberFieldObject.fields.find(formField => formField.name === 'gender').value = employerGender

    } else {
        memberFieldObject.fields.find(formField => formField.name === 'salutation').extra.optionList = salutationMasterList
        memberFieldObject.fields.find(formField => formField.name === 'salutation').value = salutationMasterList[0]
    }

    if (AuthStore.journeyTypeName === HUF && familyObj.memberType === FamilyMemberTypeEnum.FAMILYMEMBER) {
        memberFieldObject.fields.find(formField => formField.name === 'dob').extra.maxDate = ""
        memberFieldObject.fields.find(formField => formField.name === 'dob').extra.minDate = moment().subtract('years')
    }


    // set LA and PR
    //  memberFieldObject.fields.find(formField => formField.name === 'life_assured').value = memberDetails?.value?.life_assured || false;
    //  memberFieldObject.fields.find(formField => formField.name === 'proposer').value = memberDetails?.value?.proposer || false;


    if (familyObj.memberType === FamilyMemberTypeEnum.EMPLOYER && showProposer.includes(AuthStore.journeyTypeName)) {
        memberFieldObject.fields.find(formField => formField.name === 'life_assured').value = false;
        memberFieldObject.fields.find(formField => formField.name === 'life_assured').disabled = true;
        memberFieldObject.fields.find(formField => formField.name === 'proposer').value = true;

    }

    if (showProposer.includes(AuthStore.journeyTypeName) && (familyObj.memberType === FamilyMemberTypeEnum.EMPLOYEE || familyObj.memberType === FamilyMemberTypeEnum.FAMILYMEMBER)) {
        memberFieldObject.fields.find(formField => formField.name === 'life_assured').value = false;
        memberFieldObject.fields.find(formField => formField.name === 'proposer').value = false;
        memberFieldObject.fields.find(formField => formField.name === 'proposer').disabled = true;
    }


    if (isProtectionNeedSelected) {
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_value').type = "text"
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').type = "hidden"
    } else {
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_value').type = "hidden"
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').type = "text"
    }

    // Set Default gender based on the structure defined in the family member list
    if (familyObj.gender !== undefined) {
        const genderField = memberFieldObject.fields.find(formField => formField.name === 'gender')
        const selectedGender = genderField.extra.optionList.find(
            genderOptions => genderOptions.value === familyObj.gender.defaultValue
        )
        genderField.value = selectedGender
        if (familyObj.gender.isDisable !== undefined) {
            genderField.disabled = familyObj.gender.isDisable
        }
    }

    return createNewObject(memberFieldObject)

}

const preFillUserFields = (journeyData, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, memberDetails) => {

    let familyDetailsList = toJS(AuthStore.journeyData.family_details_list)

    let familyProductData = journeyData.family_product_details_list

    let familyFieldList = createFamilyMemberFieldData(lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, familyProductData, memberDetails)

    preFillFamilyDetails(
        familyFieldList,
        familyDetailsList,
        lifeCoverList,
        nationalMasterList,
        salutationMasterList,
        monthlyIncomeMasterList,
        familyProductData
    )

    return familyFieldList

}

const updateValue = (formController, familyMemberName, fieldName, value) => {

    let updatedValue = value

    // let NameRegEx = new RegExp("^([A-Za-z]{1,30})$")
    // Name Regex with space
    let NameRegEx = /^(?![\s-])[\A-Za-z.\s-]{1,50}$/

    if (fieldName == 'first_name' || fieldName == 'middle_name' || fieldName == 'last_name') {
        if (NameRegEx.test(updatedValue)) {
            updatedValue = updatedValue
        } else {
            updatedValue = formController.$("members").$(familyMemberName).$(fieldName).value
            if (updatedValue.length == 1) {
                updatedValue = ''
            }
        }

        if (updatedValue.length == 1) {
            updatedValue = updatedValue.toUpperCase()
        }
    }

    if(fieldName == 'gender'){
        let genderValue = updatedValue.value
        setSalutation(genderValue,formController, familyMemberName)
    }
    formController.$("members").$(familyMemberName).$(fieldName).value = updatedValue
}

const toggleDisableOptions = (formController, sectionName, fieldName, isDisabled) => {
    formController.$(sectionName).$(fieldName).set('disabled', isDisabled)
    if (formController.$(sectionName).$(fieldName).disabled) {
        formController.$(sectionName).$(fieldName).value = {}
        formController.$(sectionName).$(fieldName).resetValidation();
    }
}
const changeFieldValue = (formController, sectionName, fieldName, value) => {

    formController.$(sectionName).$(fieldName).value = value
    if (!checkIsValueEmpty(value)) {
        formController.$(sectionName).$(fieldName).resetValidation();
    }
}
const closeModal = (hideModal, formController) => {
    let journeyData = toJS(AuthStore.journeyData)
    reInitializeEmployeeData(journeyData, formController)
    hideModal()
}

export const reInitializeEmployeeData = (journeyData, formController) => {
    let lifeCoverList = FamilyDetailsStore.lifeCoverList
    let nationalMasterList = FamilyDetailsStore.nationalityList
    let salutationMasterList = FamilyDetailsStore.salutationList
    let monthlyIncomeMasterList = FamilyDetailsStore.monthlyIncomelist
    //let selfDetails = formController.$('members').$('self').get()
    let details = Object.entries(formController.$("members").get())

    // let selfDetailsObj = {}

    // for (let key in selfDetails) {
    //     selfDetailsObj[key] = selfDetails[key].value
    // }
    const memberDetails = details.filter((item) => item[1].extra.isSelected)
    let employeesList = preFillUserFields(journeyData, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, memberDetails)

    // familyFieldList[0].fields.forEach((item) => {

    //     const { name, value } = item

    //     if (!item.hasOwnProperty('value') || checkIsValueEmpty(value)) {
    //         item.value = selfDetailsObj[name]
    //     }
    // })

    formController?.$("members").del()

    formController.add(
        {
            name: "members",
            fields: employeesList
        }
    )
}
const validationOtherFieldEmpoyees = (formController) => {

    let ifValid = true
    const employeeList = formController.$('members').get()
    const employeeValueList = []

    for (let key in employeeList) {
      
        let { first_name, last_name, dob, gender } = employeeList[key].value
        let valueObj = { memberType: key, first_name, last_name, dob, gender }
        if (upperCase(key).startsWith(FamilyMemberTypeEnum.EMPLOYEE) || key.startsWith('family_member')) {
            employeeValueList.push(valueObj)
        }
    }

    employeeValueList.forEach((employeeObj) => {

        let { memberType, first_name, last_name, dob, gender } = employeeObj

        let journeyData = toJS(AuthStore.journeyData)
        let isProtectionNeedSelected = checkIsProtectionNeedSelected(journeyData.family_product_details_list)
        if (!checkIsValueEmpty(first_name) || !checkIsValueEmpty(last_name) || !checkIsValueEmpty(dob) || !checkIsValueEmpty(gender)) {
            let fieldNameArray

            if (isProtectionNeedSelected) {
                fieldNameArray = ['first_name', 'last_name', 'dob', 'gender', 'monthly_income_value']
            } else {
                fieldNameArray = ['first_name', 'last_name', 'dob', 'gender', 'monthly_income_dropdown_option']
            }
            
            fieldNameArray.forEach((fieldName) => {

                const isValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$(fieldName).value)
                if (isValueEmpty) {
                    formController.$("members").$(memberType).$(fieldName).invalidate("This Field is mandatory")
                    ifValid = false
                }
                else {
                    formController.$("members").$(memberType).$(fieldName).validate()
                }

            })
        }


    })

    return ifValid;
}

const checkIsMemberFieldSelected = (formController, checkDonebutton) => {

    const familyMemeberList = formController?.$('members').get()
    const employeeValueList = []
    let isselect = false

    for (let key in familyMemeberList) {
        let { first_name, last_name, dob, gender } = familyMemeberList[key].value
        let valueObj = { memberType: key, first_name, last_name, dob, gender }
        if (upperCase(key).startsWith(FamilyMemberTypeEnum.EMPLOYEE) || key.startsWith('family_member')) {
            employeeValueList.push(valueObj)
        }
    }

    employeeValueList.forEach((employee) => {
        let { memberType } = employee
        function areAllValuesNotEmpty(memberField) {
            let allFieldNotEmpty = true;

            function checkValue(value) {
                if (typeof value === 'string') {
                    if (value?.trim() === '') {
                        allFieldNotEmpty = false;
                    }
                } else if (Array.isArray(value)) {
                    value.forEach(item => checkValue(item));
                } else if (typeof value === 'object' && value !== null) {
                    Object.values(value).forEach(nestedValue => checkValue(nestedValue));
                }
            }

            checkValue(memberField);

            return allFieldNotEmpty;
        }

        const result = areAllValuesNotEmpty(employee);

        if (result) {
           
            let memberIsDisabled = formController.$("members").$(memberType).$('is_member_selected').disabled
            let memberSelected = formController.$("members").$(memberType).$('is_member_selected').value
            if (!memberSelected && memberIsDisabled) {
                updateValue(formController, memberType, 'is_member_selected', true)
            }
            formController.$("members").$(memberType).$('is_member_selected').set("disabled", false)
            isselect = true;
        }
        else {
            formController.$("members").$(memberType).$('is_member_selected').set("disabled", true)
        }
    })
    return isselect;
}

const preFillFamilyDetails = (memberFieldObjectList, familyMemberList, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, familyProductDataList) => {
    let employerDetails = familyMemberList?.find(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.EMPLOYER);
    let employeeDetailsList = familyMemberList?.filter(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.EMPLOYEE);
    let familyMemberDetailsList = familyMemberList?.filter(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.FAMILYMEMBER);
    let isProtectionNeedSelected = checkIsProtectionNeedSelected(familyProductDataList)


    memberFieldObjectList.map(item => {
        if (item.name.toUpperCase() === FamilyMemberTypeEnum.EMPLOYER) {
            if (employerDetails !== undefined) {
                setIndividualFieldValue(employerDetails, item.fields)
            }
        }

        if (item.name.toUpperCase().startsWith(FamilyMemberTypeEnum.EMPLOYEE)) {
            var currentEmployeeElement = employeeDetailsList?.shift();
            if (currentEmployeeElement !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(currentEmployeeElement, item.fields)
            }
        }

        if (item.name.toUpperCase().startsWith(FamilyMemberTypeEnum.FAMILYMEMBER)) {
            var currentFamilyMemberElement = familyMemberDetailsList?.shift();
            if (currentFamilyMemberElement !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(currentFamilyMemberElement, item.fields)
            }
        }
        return item
    })
}
const setFamilyMemberFieldValue = (fieldList, fieldName, fieldApiValue, fieldType = FieldTypeEnum.NORMAL) => {

    if (fieldApiValue == null) return

    switch (fieldType) {
        case FieldTypeEnum.GENDER_DROPDOWN:
            setDropDownOptionsListValue(fieldList, fieldName, fieldApiValue)
            break

        case FieldTypeEnum.MASTER_DATA:
            setMasterFieldValue(fieldList, fieldName, fieldApiValue)
            break

        default:
            fieldList.find(fieldObj => fieldObj.name == fieldName).value = fieldApiValue
            break
    }
}


const setMasterFieldValue = (fieldList, fieldName, fieldApiValue) => {
    let field = fieldList.find(fieldObj => fieldObj.name == fieldName)
    let selectedFieldValue = field.extra.optionList.find(fieldData => fieldData.id == fieldApiValue)
    if (selectedFieldValue !== undefined) {
        field.value = selectedFieldValue
    }
}

const setDropDownOptionsListValue = (fieldList, fieldName, fieldApiValue) => {
    let field = fieldList.find(fieldObj => fieldObj.name == fieldName)
    let selectedFieldValue = field.extra.optionList.find(fieldData => fieldData.value.toLowerCase() == fieldApiValue.toLowerCase())
    if (selectedFieldValue !== undefined) {
        field.value = selectedFieldValue
    }
}


const setIndividualFieldValue = (familyMemberApiData, field) => {

    setFamilyMemberFieldValue(field, 'id', familyMemberApiData.id)
    setFamilyMemberFieldValue(field, 'first_name', familyMemberApiData.first_name)
    setFamilyMemberFieldValue(field, 'middle_name', familyMemberApiData.middle_name)
    setFamilyMemberFieldValue(field, 'last_name', familyMemberApiData.last_name)
    setFamilyMemberFieldValue(field, 'dob', familyMemberApiData.dob)
    setFamilyMemberFieldValue(field, 'monthly_income_value', familyMemberApiData.monthly_income)
    setFamilyMemberFieldValue(field, 'gender', familyMemberApiData.gender, FieldTypeEnum.GENDER_DROPDOWN)
    setFamilyMemberFieldValue(field, 'nationality', familyMemberApiData.nationality, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'current_life_cover', familyMemberApiData.current_life_cover, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'salutation', familyMemberApiData.salutation, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'monthly_income_dropdown_option', familyMemberApiData.monthly_income_dropdown_option, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'is_member_selected', familyMemberApiData.is_member_selected)

    // if (familyMemberApiData.monthly_income !== null) {
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_value').type = 'text'
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_dropdown_option').type = 'hidden'
    // } else {
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_dropdown_option').type = 'text'
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_value').type = 'hidden'
    // }
}


const getEligibleProposerList = async (memberDetails, formController, journeyData) => {
    if (memberDetails[1].value.id) {
        global.loading(true);
        let selectedNeedId = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 4)
        if (!selectedNeedId) {
            selectedNeedId = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need !== 4)
        }
       
        const proposerListResponse = await axios.post(APITypes.GET_ELIGIBLE_PROPOSER_LIST, {
            journey_id: AuthStore.journeyId,
            need_id: selectedNeedId.need,
            family_member_id: memberDetails[1].value.id,
        });
        console.log("proposerListResponse", proposerListResponse)
        if (proposerListResponse?.status?.toLowerCase() === "success") {
          
            let familyData = Object.entries(formController.$("members").get())
            let selectedPr = familyData.find((item) => item[1].value.proposer)
            let isProtectionNeedSelected = checkIsProtectionNeedSelected(journeyData.family_product_details_list)
            let alreadySelectedPr = false
            if (selectedPr) {
                alreadySelectedPr = proposerListResponse?.data?.some((item) => item?.family_member_type.toLowerCase() === selectedPr[0].replace(/[0-9]/g, ''))
            }
            familyData.forEach((data) => {
                let isEligibleMember = proposerListResponse.data.some((item) => item.family_member_type.toLowerCase() === data[0].replace(/[0-9]/g, ''))
                if (!isEligibleMember) {
                    if (alreadySelectedPr && selectedPr[0] !== data[0]) {
                        updateValue(formController, data[0], "proposer", false)
                    } else if (!alreadySelectedPr) {
                        updateValue(formController, data[0], "proposer", false)
                        updateValue(formController, proposerListResponse.data[0].family_member_type.toLowerCase(), "proposer", true)
                    }
                    if (!isProtectionNeedSelected) {
                        formController.$("members").$(data[0]).$("proposer").set("disabled", true)
                    }
                } else {
                    if (!isProtectionNeedSelected) {
                        formController.$("members").$(data[0]).$("proposer").set("disabled", false)
                    }
                }
            })
        }
        global.loading(false);
    }
}

const fecthGenderOptionList = function (memberType) {
    if (memberType === 'employer') {
        return [
            { id: 3, label: 'Company', value: 'Company' },
        ]
    } else {
        return [
            { id: 1, label: 'Male', value: 'Male' },
            { id: 2, label: 'Female', value: 'Female' }
        ]
    }

}
const removeEmptyObject = (objectData) => {
    let itemdata = []
    for (const item in objectData) {
        if (!isObjectEmpty(objectData[item])) {
            itemdata.push(objectData[item])
        }
    }
    return createNewObject(itemdata)
}

const setSalutation = (gender, formController, familyMemberName) => {

    let salutationList = familyMemberName.startsWith("employee") ? formController.$("members").$('employee1').$('salutation').extra.optionList : formController.$("members").$('family_member1').$('salutation').extra.optionList 
        if (gender === "Female") {
            let salutation = salutationList.find((item) => item.label === "Ms.")
            formController.$("members").$(familyMemberName).$("salutation").value = salutation
        } else if(gender === "Male") {
            let salutation = salutationList.find((item) => item.label === "Mr.")
            formController.$("members").$(familyMemberName).$("salutation").value = salutation
        }else if(gender === "Company"){
            let salutation = salutationList.find((item) => item.label === "M/S")
            formController.$("members").$(familyMemberName).$("salutation").value = salutation
        }
    
}

export { createFamilyMemberFieldData, preFillUserFields, checkIsProtectionNeedSelected, generateMemberEmptyDataStrucutre, updateValue, toggleDisableOptions, changeFieldValue, closeModal, checkIfFamilyMemberAreAdded, addEmployees, addNewMember, validationOtherFieldEmpoyees, checkIsMemberFieldSelected, setIndividualFieldValue, getEligibleProposerList, fecthGenderOptionList ,sendnonIndividualDataToServer ,removeEmptyObject}